import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import MaterialUIAvatar from '@material-ui/core/Avatar';
import { withStyles } from '@material-ui/core/styles';

import Theme from 'LegacyWeployDesignLanguage/Theme';
import Typography from 'WeployDesignLanguage/Typography';

const EXTRA_EXTRA_SMALL = 'EXTRA_EXTRA_SMALL';
const EXTRA_SMALL = 'EXTRA_SMALL';
const SMALL = 'SMALL';
const MEDIUM = 'MEDIUM';
const LARGE = 'LARGE';

const GREEN = 0;
const PURPLE = 1;
const DARK_BLUE = 2;
const BLUE = 3;
const ORANGE = 4;
const YELLOW = 5;
const DARK_GREEN = 6;
const TURQUOISE = 7;
const BROWN = 8;
const RED = 9;
const GREY = 10;
const DARKER_GREEN = 11;

const commonStyles = {
  defaultStyles: {
    color: Theme.colors.white,
  },
};

const styles = {
  [GREEN]: { backgroundColor: '#79C62D' },
  [PURPLE]: { backgroundColor: '#7030BE' },
  [DARK_BLUE]: { backgroundColor: '#3E4EBC' },
  [BLUE]: { backgroundColor: '#0096FB' },
  [ORANGE]: { backgroundColor: '#FF9300' },
  [YELLOW]: { backgroundColor: '#FFC000' },
  [DARK_GREEN]: { backgroundColor: '#009988' },
  [TURQUOISE]: { backgroundColor: '#00BFD8' },
  [BROWN]: { backgroundColor: '#7F5345' },
  [RED]: { backgroundColor: '#FF4500' },
  [GREY]: { backgroundColor: '#BCBCBC' },
  [DARKER_GREEN]: { backgroundColor: '#17524A' },
  [EXTRA_EXTRA_SMALL]: {
    ...commonStyles,
    width: 24,
    height: 24,
    fontSize: '12px',
  },
  [EXTRA_SMALL]: {
    ...commonStyles,
    width: 60,
    height: 60,
    fontSize: '28px',
  },
  [SMALL]: {
    ...commonStyles,
    width: 80,
    height: 80,
    fontSize: '38px',
  },
  [MEDIUM]: {
    ...commonStyles,
    width: 100,
    height: 100,
    fontSize: '48px',
  },
  [LARGE]: {
    ...commonStyles,
    width: 150,
    height: 150,
    fontSize: '73px',
  },
};

const StyledAvatar = styled(MaterialUIAvatar)`
  &.MuiAvatar-root {
    ${props => props.width && css`
    width: ${props.width};
    `};

    ${props => props.height && css`
      height: ${props.height};
    `};
  }
`;
const StyledSpan = styled.span`
  font-size: ${props => styles[props.size].fontSize};
`;

const Avatar = (props) => {
  const {
    classes,
    width,
    height,
    size,
    backgroundColor,
    text,
    src,
    alt,
  } = props;
  const classNames = `${classes[size]} ${classes[backgroundColor]}`;

  return (
    <StyledAvatar
      className={classNames}
      src={src}
      alt={alt}
      width={width}
      height={height}
    >
      { text &&
        <Typography variant="caption" color="textPrimaryOnDark" component="span">
          <StyledSpan size={size}>
            {text}
          </StyledSpan>
        </Typography>
      }
    </StyledAvatar>
  );
};

Avatar.propTypes = {
  size: PropTypes.oneOf([EXTRA_EXTRA_SMALL, EXTRA_SMALL, SMALL, MEDIUM, LARGE]),
  width: PropTypes.string,
  height: PropTypes.string,
  backgroundColor: PropTypes.oneOf([GREEN, PURPLE, DARK_BLUE, BLUE, ORANGE, YELLOW, DARK_GREEN, TURQUOISE, BROWN, RED]),
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  src: PropTypes.string,
  alt: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

Avatar.defaultProps = {
  size: MEDIUM,
  width: null,
  height: null,
  backgroundColor: GREEN,
  text: '',
  src: '',
  alt: '',
};

Avatar.EXTRA_EXTRA_SMALL = EXTRA_EXTRA_SMALL;
Avatar.EXTRA_SMALL = EXTRA_SMALL;
Avatar.SMALL = SMALL;
Avatar.MEDIUM = MEDIUM;
Avatar.LARGE = LARGE;

Avatar.GREEN = GREEN;
Avatar.PURPLE = PURPLE;
Avatar.DARK_BLUE = DARK_BLUE;
Avatar.BLUE = BLUE;
Avatar.ORANGE = ORANGE;
Avatar.YELLOW = YELLOW;
Avatar.DARK_GREEN = DARK_GREEN;
Avatar.DARKER_GREEN = DARKER_GREEN;
Avatar.TURQUOISE = TURQUOISE;
Avatar.BROWN = BROWN;
Avatar.RED = RED;
Avatar.GREY = GREY;

Avatar.COLORS = [GREEN, PURPLE, DARK_BLUE, BLUE, ORANGE, YELLOW, DARK_GREEN, TURQUOISE, BROWN, RED];

export default withStyles(styles)(Avatar);
